import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/settings` leads to the account page. */
export const Route = createFileRoute("/_app/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/account", replace: true });
  },
});
